
import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Button,
  Modal ,
  Grid,
  TextField,
  Typography ,
} from "@mui/material";
import upload from '../../../Img/upload.svg'
import selfie from '../../../Img/selfie.png'
import { styled } from '@mui/material/styles';




export default function Selfiephoto({aadhardata}) { 
    const [ok_done, setok_done] = React.useState(false);

   const dfdf = () =>{
    setok_done(true);
   }
 
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
 

    const [otp, setOtp] = useState(['', '', '', '', '', '']);

    const handleOtpChange = (index, event) => {
      const value = event.target.value;
      const newOtp = [...otp];
  
      // Ensure only numbers are entered
      const numericValue = value.replace(/\D/g, '');
  
      // Limit the input to a single digit
      newOtp[index] = numericValue.slice(0, 1);
  
      setOtp(newOtp);
  
      // Focus on the next input field if a digit is entered
      if (numericValue.length > 0 && index < 5) {
        const nextInput = document.getElementById(`otp-input-${index + 1}`);
        nextInput && nextInput.focus();
      }
    };
  


  const [firstField, setFirstField] = useState('');
  const [secondField, setSecondField] = useState('');
  const [thirdField, setThirdField] = useState('');

  const handleInputChange = (field, value) => {
    const trimmedValue = value.slice(0, 4); // Limit to 4 characters
    switch (field) {
      case 'first':
        setFirstField(trimmedValue);
        break;
      case 'second':
        setSecondField(trimmedValue);
        break;
      case 'third':
        setThirdField(trimmedValue);
        break;
      default:
        break;
    }
  };


  const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
  });
   
    const [frontimage, setfrontimage] = React.useState(null);
    const [backimage, setbackimage] = React.useState(null);
  
    // Handle the change in file input (on file selection)
    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        const imageUrl = URL.createObjectURL(file); // Generate image URL
        setfrontimage(imageUrl); // Set the image URL to the state
      } 
    }

    const handleFileChange1 = (event) => {
        const file = event.target.files[0];
        if (file) {
          const imageUrl = URL.createObjectURL(file); // Generate image URL
          setbackimage(imageUrl); // Set the image URL to the state
        } 
      }
  
  
 

  return (
    <div>
      


          <div className="aadhar_sec" >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{margin:"auto"}} >
                  <h4><span>Selfie Photo </span> Verification</h4>
                  <div className="note"><span>Note:</span> Authentic self-portrait for verification purposes. Ensuring transparency and trust in the process.
                  </div>
                  <div className="display-3 mt-30">
                  <img src={selfie} alt="img" />
                  </div>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6} style={{margin:"auto"}} >
                <p>Upload your Front & Back PAN Card photo</p>
                <div className="ulpoads" > 
                    {frontimage && (
                    <div className="upload_box" >
                        <img
                            src={frontimage}
                            alt="Selected"
                            style={{maxWidth: '100%',height:"auto"}}
                        />
                        </div>
                    )}
                    {!frontimage && (
                        <div className="upload_box" >
                        <Button component="label" variant="contained" tabIndex={-1} >
                        <img src={upload} alt="img" />
                        
                        <p>Upload Image here</p>
                            <VisuallyHiddenInput
                            type="file"
                            onChange={handleFileChange}
                            accept="image/*"
                            />
                        </Button>
                        </div>
                    )} 
                </div>
                {frontimage &&
                 <Link to={"#"} className='org_btn sm_txt' style={{padding:"12px 60px",margin:"20px 0 0",borderRadius:"8px",display:"flex",alignItems:"center",gap:"10px",width:"50%",
                    borderRadius:"6px",textAlign:"center",justifyContent:"center"
                    }}  >Submit
                  </Link>
                }
               {!frontimage  &&
                  <Link className='grey_btn' disabled style={{display:"block",padding:"12px 10px",margin:"20px 0",borderRadius:"8px",width:"50%",}} >Upload </Link>
                }
              </Grid>
            </Grid>
          </div>

    </div>
  );
}
